import {Space} from "antd";
import {useGetUserSchedules} from "../../../../../../react-query-hooks/schedule";
import {UserScheduleItem} from "../schedule-item";
import {StyledUserScheduleList, StyledUserScheduleListTitle} from "./styles";

export function UserScheduleList() {
  const {data} = useGetUserSchedules();
  // console.log({data});
  return (
    <StyledUserScheduleList>
      <Space size={24} direction="vertical" style={{display: "flex"}}>
        <StyledUserScheduleListTitle>
          Create schedules to set your availability and apply them to your 1:1 session(s)
        </StyledUserScheduleListTitle>
        <div>
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            {data?.schedules &&
              data.schedules.length > 0 &&
              data.schedules.map((si, index) => {
                return (
                  <UserScheduleItem
                    key={si.id}
                    scheduleId={si.id}
                    numberOfSessions={si.sessionCount}
                    scheduleName={si.name}
                    isDefault={si.isDefault}
                    index={index}
                  />
                );
              })}
          </Space>
        </div>
      </Space>
    </StyledUserScheduleList>
  );
}
